<template>
  <div class="hot-route">
      <div class="hot-route-header">
        <h3 class="hot-route-title">热门线路</h3>
        <div class="line-bold"></div>
      </div>
      <div class="hot-router-sub-title">
          在这里您可以看到大家喜欢的热门路线
      </div>
      <div class="hot-route-refresh">
          <div class="hot-route-refresh-name" @click='change'>换一批</div>
          <div class="hot-route-refresh-img"></div>
      </div>
      <div class="hot-router-main">
          <div class="hot-router-list" v-for="(item, index) in hotlists" :key="index" :class="item.active?'hot-router-list-active':''" @mouseenter="listMouseenter(index)" >
              <img :src="item.thumbnail" alt="">
              <div class="hot-router-list-content" v-show="item.active">
                  <h4 class="hot-router-list-title">
                      {{item.title}}
                  </h4>
                  <p class="hot-router-list-time">{{item.time}}</p>
                  <p class="hot-router-list-address">{{item.venue}}</p>
                  <div class="hot-router-list-detail" @click='gotodetail(item)'>查看详情</div>
              </div>
              <div class="hot-router-list-tag" v-show="item.active">
                  <p v-for="(tagItem, tagIndex) in item.topTags" :key="tagIndex">{{tagItem}}</p>
              </div>
              <div class="small-pop" v-show="!item.active"></div>
              <div class="hot-router-list-footer" v-show="!item.active">

                  <p class="hot-router-list-footer-title">
                      {{item.title}}
                  </p>
                  <p class="hot-router-list-footer-address">
                      一 <span>{{item.venue}}</span> 一
                  </p>
              </div>
          </div>
      </div>
      <div class="hot-router-footer">
          <div class="hot-router-footer-list" v-for="(item, index) in lists2" :key="index" @click='gotodetail(item)'>
              <img :src="item.thumbnail" alt="">
              <div class="small-pop"></div>
              <div class="hot-router-list-tag">
                  <p v-for="(tagItem, tagIndex) in item.topTags" :key="tagIndex">{{tagItem}}</p>
              </div>
              <div class="hot-router-footer-main">
                  <p class="hot-router-footer-main-title">
                    {{item.title}}
                  </p>
                  <div class="hot-router-footer-main-time">
                      <svg-icon icon-class="time2"></svg-icon>
                      旅行时间:{{item.time}}
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import HotRouterImg from '@/assets/img/hot-router-img.png'
import TimeIcon from '@/assets/img/time-icon.png'
import {contentlist, getthemelist} from '@/api/theme.js'
import {querycontent} from '@/api/content.js'
import {sliceDate} from '@/utils/index'
export default {
  name: 'HotRoute',
  data () {
    return {
      TimeIcon,
      lists: [
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: true
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: false
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: false
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: false
        }
      ],
      lists2: [
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: true
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: false
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          active: false
        }
      ],
      themes: [],
      querylist: {
        page: 1,
        limit: 10
      },
      hotlists: [],
      hotquery: {
        page: 1,
        limit: 8,
        isHot: true,
        sort: 'hot_order_no',
        order: 'asc'
      },
      hottotal: 0,
      waringword: ''
    }
  },
  methods: {
    resetListHover () {
      let lists = this.hotlists

      lists.forEach(item => {
        item.active = false
      })
    },
    listMouseenter (index) {
      this.resetListHover()
      this.hotlists[index].active = true
    },
    getlist () {
      contentlist(this.querylist).then(res => {
        console.log(res)
      })
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.gethotlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          items[i].classes = this.themes[items[i].themeId]
          items[i].active = false
        }
        items[0].active = true
        this.hotlists = items.slice(0, 4)
        this.lists2 = items.slice(4, 8)
        console.log(this.lists2)
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 8) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    },
    gotodetail (item) {
      this.$router.push({
        path: '/routeDetail',
        query: {
          id: item.id,
          img: item.thumbnail
        }
      })
    }
  },
  created () {
    this.getthemelist()
  }
}
</script>

<style lang="scss" scoped>
.hot-route {
    margin-top: 60px;
    width: 100%;
    .hot-route-header {
        width: 780px;
        border-bottom: 1px solid #dae1e6;
        margin: 0 auto;
        position: relative;
        padding-bottom:8px;
    }
    .hot-route-title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 34px;
        color: #60676d;
    }
    .line-bold {
        width: 44px;
        height: 3px;
        position: absolute;
        left: 50%;
        bottom: -2px;
        margin-left: -22px;
        background: #0080cc;
    }
    .hot-router-sub-title {
        width: 100%;
        text-align: center;
        color: #a3abb2;
        font-size: 16px;
        margin-top: 10px;
    }
    .hot-route-refresh {
        width: 1232px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0 auto;
        cursor: pointer;
        &:hover {
            .hot-route-refresh-name {
                color: #0281cc;
            }
            .hot-route-refresh-img {
                background: url(../../assets/img/refresh-icon.png);
            }
        }
    }
    .hot-route-refresh-name {
        font-size: 14px;
        color: #0281cc;
        font-weight: bold;
        color: #a3abb2;
    }
    .hot-route-refresh-img {
        width: 14px;
        height: 14px;
        margin-left: 6px;
        background: url(../../assets/img/refresh-icon-gray.png);
    }
    .hot-router-main {
        cursor: pointer;
        width: 1232px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        img {
            width: 575px;
            height: 462px;
        }
    }
    .hot-router-list {
        width: 218px;
        height: 372px;
        overflow: hidden;
        margin-top: 10px;
        position: relative;
        transition: width 0.3s;
    }
     .hot-router-list-active {
         width: 575px;
         transition: width 0.3s;
     }
     .hot-router-list-content {
         width: 480px;
         background: rgba($color: #000000, $alpha: 0.4);
         position: absolute;
         top: 50%;
         left: 50%;
         z-index: 1000;
         transform: translate(-50%, -50%);
        //  padding-bottom:28px;
        padding:28px;
        box-sizing: border-box;
         .hot-router-list-title {
             width: 100%;
             color: #fff;
             font-size: 30px;
             font-weight: bold;
             text-align: center;
            //  margin-top: 20px;
             overflow: hidden;
             text-overflow:ellipsis;
             white-space: nowrap;
         }
         .hot-router-list-time {
             margin-top: 20px;
         }
         .hot-router-list-time,.hot-router-list-address {
             font-size: 14px;
             color: #eaeaea;
             width: 100%;
             text-align: center;
             font-weight: bold;
             margin-top:10px;
         }
         .hot-router-list-detail {
             width: 180px;
             height: 40px;
             background: #0080cc;
             font-size: 16px;
             color: #ffffff;
             display: flex;
             justify-content: center;
             align-items: center;
             border-radius: 5px;
             margin: 20px auto 0;
         }
     }
    .hot-router-list-tag{
        position: absolute;
        top: 0;
        left: 0;
        padding-bottom: 10px;
        background: rgba(0, 0, 0, 0.2);
        z-index: 1000;
        display: flex;
        p {
            font-size: 14px;
            color: #fff;
            font-weight: 300;
            padding: 0px 13px;
            line-height: 1;
            margin-top: 10px;
            border-right: 1px solid #fff;
            &:last-child {
                border: none;
            }
        }
    }
    .hot-router-list-footer {
        position: absolute;
        left: 0;
        bottom: 20px;
        right: 0;
        z-index: 1000;
        color: #fff;
        text-align: center;
        line-height: 24px;
        font-weight: bold;
    }
    .small-pop{
      width:100%;
      height:100%;
      background: rgba(0,0,0,0.4);
      // opacity: 40%;
      position:absolute;
      left: 0;
    top: 0;

    }
    .hot-router-list-footer-title {
        font-size: 17px;
        padding: 0 20px;
    margin-bottom: 10px;
    }
    .hot-router-list-footer-address {
        font-size: 14px;
        color: #767f88;
        span {
            color: #fff;
        }
    }
    .hot-router-footer {
        width: 1230px;
        margin: 10px auto 0;
        display: flex;
        justify-content: space-between;
    }
    .hot-router-footer-list {
        width: 410px;
        height: 287px;
        overflow: hidden;
        position: relative;
        img {
            width: 410px;
            height: 410px;
        }
    }
    .hot-router-footer-list:hover{
      cursor: pointer;
    }
    .hot-router-footer-list:hover .small-pop{
      transition: all 0.3s;
      background: rgba(0,0,0,0)
    }
    .hot-router-footer-list:hover .hot-router-list-tag{
      transition: all 0.3s;
      background: rgba(0,0,0,0.7)
    }
    .hot-router-footer-list:hover .hot-router-footer-main{
      transition: all 0.3s;
      background: rgba(0,0,0,0.7)
    }
    .hot-router-footer-main {
        width: 100%;
        // height: 287px;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1000;
    }
    .hot-router-footer-main-title {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        margin: 15px;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .hot-router-footer-main-time {
        color: #fff;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        font-size: 14px;
        svg {
            font-size: 15px;
            margin: 0 5px 0 15px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/hotRoute.vue